









































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import Moment from 'moment';

@Component
export default class StockBalanceView extends Vue {
  public items: Common.StockBalance[] = new Array(0);
  public params: Common.StockBalanceQuery = new Common.StockBalanceQuery();
  // public importQuery = new Common.StockTakingImportQuery('実地棚卸');
  // public exportQuery = new Common.StockTakingExportQuery('実地棚卸',this.params);
  public exportQuery = new Common.StockBalanceExportQuery('在庫一覧',this.params);
  public purchaseDeliveryVoucherType = Common.VoucherTypes.SalesDelivery;
  public salesDeliveryVoucherType = Common.VoucherTypes.SalesDelivery;
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;
  public usedTypes = Common.UsedTypes;
  public hasLicenseCurrency: boolean = false;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;
  @Prop() public closingDate:Date;
  @Prop() public segment:Common.Segment;  
  @Prop() public warehouse:Common.Counterpart;    
  @Prop() public projectItem:Common.ProjectItem;    
  @Prop({default:false}) public excludeProject: boolean;   
  @Prop({default:null}) public popup: Components.PopupEditor;
  @Prop({default:false}) public isStockPopup: boolean;  
  public sortOptions: any = [
    // { value: 'id', text: 'ID' },
    { value: 'warehouse', text: '倉庫' },    
    { value: 'segment', text: '部門' },
    { value: 'commodity', text: '商品' },
    { value: 'sku', text: 'SKU' },
    { value: 'commodityCode', text: '商品コード' },
    { value: 'projectItem', text: '案件' },    
  ];

  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();

  public stockTakingImportQuery = new Common.StockTakingImportQuery('実地棚卸');
  public stockTakingExportQuery = new Common.StockTakingExportQuery('実地棚卸',this.params);
  public migrationImportQuery = new Common.MigrationImportQuery('在庫移行');
  public migrationExportQuery = new Common.MigrationExportQuery('在庫移行',this.params);

  public created() {
    this.tenantSettings = this.$api.tenantSettings;
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItemsFromCaptions(
      // ['限月', '部門', '倉庫', '商品', 'SKU','繰越数量', '繰越金額', '移行数量', '移行金額', '未着数量', '未着金額', '仕入数量', '仕入金額', '仕入諸掛金額', '振替数量', '振替金額', '積送数量', '積送金額', '売上数量', '売上金額', '売上諸掛金額', '減耗数量', '在庫数量', '予定入荷数量', '予定出荷数量', '予定在庫数量', '払出金額', '在庫単価', '在庫金額', '入荷明細ID',],
      // [120, 120, 120, 120, 120,120, 120, 120, 120, 120, 120, 120, 120, 150, 120, 120, 120, 120, 120, 120, 150, 120, 120, 150, 150, 150, 150, 150, 150, 120, 120, 120,120]
      ['限月', '部門', '倉庫','案件', '商品コード', '商品', '型番', 'SKU','繰越在庫数量', '繰越在庫金額', '仕入数量', '仕入金額', '仕入諸掛金額', '振替数量', '振替金額','売上数量', '売上金額', '売上諸掛金額', '払出金額',  '減耗数量','減耗金額', '在庫数量','(庫内数量)','(積送数量)', '在庫単価', '在庫金額'],
      [120, 120, 120,120, 120, 120, 150, 150, 120, 120, 150, 120, 120, 120, 120, 150, 120, 120, 120, 120, 150, 120, 120,]
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));

    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.closingDate)this.params.closingDate = this.closingDate;
    if (this.segment)this.params.segment = this.segment;
    if (this.warehouse) this.params.warehouse = this.warehouse;
    if (this.projectItem) this.params.projectItem = this.projectItem;    
    if (this.excludeProject) this.params.excludeProject = this.excludeProject;
  }
  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.CommodityMemo ;
  }
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }

  // 在庫数量詳細
  public sbqFooterMigrationQuantity: number = 0;
  public sbqFooterUndeliveredQuantity: number = 0;
  public sbqFooterPurchaseQuantity: number = 0;
  public sbqFooterTransferQuantity: number = 0;
  public sbqFooterConsignmentQuantity: number = 0;
  public sbqFooterSalesQuantity: number = 0;
  public sbqFooterDifferentialQuantityActual: number = 0;
  public sbqFooterTotalUndeliveredQuantity: number = 0;
  public sbqFooterTotalConsignmentQuantity: number = 0;
  public sbqFooterTotalStockQuantity: number = 0;
  public sbqFooterStockQuantity: number = 0;
  public sbqFooterSchedulePurchaseQuantity: number = 0;
  public sbqFooterScheduleSalesQuantity: number = 0;
  public sbqFooterScheduleStockQuantity: number = 0;
  public sbqFooterQuantityScale = 0;
  public showStockBalanceQuantityDialog(){
    this.$api.startWaitCusor();
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;

    this.sbqFooterQuantityScale = stockBalance.stockKey.commodity.quantityScale;
    this.sbqFooterMigrationQuantity = stockBalance.migrationQuantity;
    // クエリの設定
    var query = new Common.StockBalanceDetailQuery();
    query.stockBalance = stockBalance;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.sbqFooterUndeliveredQuantity =  journals.map(obj => obj.undeliveredQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterPurchaseQuantity = journals.map(obj => obj.purchaseQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterTransferQuantity = journals.map(obj => obj.transferQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterConsignmentQuantity = journals.map(obj => obj.consignmentQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterSalesQuantity = journals.map(obj => obj.salesQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterDifferentialQuantityActual = journals.map(obj => obj.differentialQuantityActual).reduce((total, value) =>(total + value));
      this.sbqFooterTotalUndeliveredQuantity = journals[journals.length -1].totalUndeliveredQuantity;
      this.sbqFooterTotalConsignmentQuantity = journals[journals.length -1].totalConsignmentQuantity;
      this.sbqFooterTotalStockQuantity = journals[journals.length -1].totalStockQuantity;
      this.sbqFooterStockQuantity = journals[journals.length -1].stockQuantity;
      this.sbqFooterSchedulePurchaseQuantity = journals.map(obj => obj.schedulePurchaseQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterScheduleSalesQuantity = journals.map(obj => obj.scheduleSalesQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterScheduleStockQuantity = journals[journals.length -1].totalScheduleStockQuantity;
      (this.$refs.stockBalanceQuantityDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
      (this.$refs.stockBalanceQuantityDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());
  }

  // 在庫金額詳細
  public sbaFooterMigrationAmount: number = 0;
  public sbaFooterUndeliveredAmount: number = 0;
  public sbaFooterPurchaseAmount: number = 0;
  public sbaFooterPurchaseChargeAmount: number = 0;
  public sbaFooterTransferAmount: number = 0;
  public sbaFooterConsignmentAmount: number = 0;
  public sbaFooterSalesAmount: number = 0;
  public sbaFooterSalesChargeAmount: number = 0;
  public sbaFooterQuantityLossAmount: number = 0;
  public sbaFooterWithDrawAmount: number = 0;
  public sbaFooterTotalUndeliveredAmount: number = 0;
  public sbaFooterTotalConsignmentAmount: number = 0;
  public sbaFooterStockAmount: number = 0;
  public sbaFooterTotalStockAmount: number = 0;
  public sbaFooterAmountScale: number = 0;

  public showStockBalanceAmountDialog(){
    this.$api.startWaitCusor();
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;

    this.sbaFooterAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);
    this.sbaFooterMigrationAmount = stockBalance.migrationAmount;
    // クエリの設定
    var query = new Common.StockBalanceDetailQuery();
    query.stockBalance = stockBalance;
    query.amountFlag = true;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.sbaFooterUndeliveredAmount =  journals.map(obj => obj.undeliveredAmount).reduce((total, value) =>(total + value));
      this.sbaFooterPurchaseAmount = journals.map(obj => obj.purchaseAmount).reduce((total, value) =>(total + value));
      this.sbaFooterPurchaseChargeAmount = journals.map(obj => obj.purchaseChargeAmount).reduce((total, value) =>(total + value));
      this.sbaFooterTransferAmount = journals.map(obj => obj.transferAmount).reduce((total, value) =>(total + value));
      this.sbaFooterConsignmentAmount = journals.map(obj => obj.consignmentAmount).reduce((total, value) =>(total + value));
      this.sbaFooterSalesAmount = journals.map(obj => obj.salesAmount).reduce((total, value) =>(total + value));
      this.sbaFooterSalesChargeAmount = journals.map(obj => obj.salesChargeAmount).reduce((total, value) =>(total + value));
      this.sbaFooterQuantityLossAmount = journals.map(obj => obj.quantityLossAmount).reduce((total, value) =>(total + value));
      this.sbaFooterWithDrawAmount = journals.map(obj => obj.withDrawAmount).reduce((total, value) =>(total + value));
      this.sbaFooterTotalUndeliveredAmount = journals[journals.length -1].totalUndeliveredAmount;
      this.sbaFooterTotalConsignmentAmount = journals[journals.length -1].totalConsignmentAmount;
      this.sbaFooterTotalStockAmount = journals[journals.length -1].totalStockAmount;

      this.sbaFooterTotalConsignmentAmount = stockBalance.totalConsignmentAmount;
      this.sbaFooterStockAmount = stockBalance.stockAmount;

      (this.$refs.stockBalanceAmountDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
      (this.$refs.stockBalanceAmountDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());
  }

  // 単価詳細プロパティ
  public spdFooterReceiptQuantity: number = 0;
  public spdFooterReceiptAmount:number = 0;
  public spdFooterWithDrawQuantity: number = 0;
  public spdFooterWithDrawAmount: number = 0;
  public spdMonthlyAverage:boolean = false;
  public spdMovingAverage:boolean = false;
  public spdLastPurchase:boolean = false;
  public spdSpecific:boolean = false;
  public spdFooterQuantity: number = 0;
  public spdFooterAmount: number = 0;
  public spdFooterPrice: number = 0;
  public spdItemName1: string = '';
  public spdItemName2: string = '';
  public spdItemName3: string = '';
  public spdQuantityScale: number = 0;
  public spdAmountScale: number = 0;
  public spdPriceScale: number = 0;
  public get spdMonthlyOrMoving():boolean
  {
    if (this.spdMonthlyAverage || this.spdMovingAverage) return true;
    else return false;
  }
  public spdListCaptions = new Array();
  public spdListWidths = new Array();
  public spdListSlots = new Array();
  public spdGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');
  public showStockPricingDetailDialog(){
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;
    if(stockBalance.stockPricingId == null){
      this.$api.modal.show('', '単価情報が存在しません。', true, null);
      return;
    }

    this.spdQuantityScale = stockBalance.stockKey.commodity.quantityScale;
    this.spdPriceScale = stockBalance.stockKey.commodity.stockPriceScale;
    this.spdAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);

    this.$api.startWaitCusor();
    this.spdMonthlyAverage = false;
    this.spdMovingAverage = false;
    this.spdSpecific = false;
    this.spdLastPurchase = false;
    if (stockBalance.stockKey.deliveryId != null || stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific)
    {
      this.spdSpecific = true;
      this.spdItemName1 = '個別数量';
      this.spdItemName2 = '個別金額';
      this.spdItemName3 = '個別単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.MonthlyAverage)
    {
      this.spdMonthlyAverage = true;
      this.spdItemName1 = '総平均数量';
      this.spdItemName2 = '総平均金額';
      this.spdItemName3 = '総平均単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.MovingAverage)
    {
      this.spdMovingAverage = true;
      this.spdItemName1 = '移動平均数量';
      this.spdItemName2 = '移動平均金額';
      this.spdItemName3 = '移動平均単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.LastPurchase)
    {
      this.spdLastPurchase = true;
      this.spdItemName1 = '最終原価数量';
      this.spdItemName2 = '最終原価金額';
      this.spdItemName3 = '最終原価単価'
    }

    this.spdFooterReceiptQuantity = 0;
    this.spdFooterReceiptAmount = 0;
    this.spdFooterWithDrawQuantity = 0;
    this.spdFooterWithDrawAmount = 0;
    this.spdFooterQuantity = 0;
    this.spdFooterAmount = 0;
    this.spdFooterPrice = 0;
    this.spdListCaptions = new Array();
    this.spdListWidths = new Array();
    this.spdListSlots = new Array();
    this.spdGridConfig = new Common.GridConfiguration([],0, 'col');

    this.spdGridConfig.setGridItems(
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('伝票区分', 150),
      new Common.GridItemConfiguration('伝票明細番号', 180),
      new Common.GridItemConfiguration('受入数量', 150),
      new Common.GridItemConfiguration('受入単価', 150),
      new Common.GridItemConfiguration('受入金額', 150),
      new Common.GridItemConfiguration('払出数量', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration('払出単価', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration('払出金額', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration(this.spdItemName1, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName2, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName3, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName1, 150 , this.spdLastPurchase),
      new Common.GridItemConfiguration(this.spdItemName2, 150 , this.spdLastPurchase),
      new Common.GridItemConfiguration(this.spdItemName3, 150 , this.spdLastPurchase),
    );
    this.spdListCaptions = this.spdGridConfig.gridCaptions;
    this.spdListWidths = this.spdGridConfig.gridWidths;
    this.spdListSlots = this.spdGridConfig.gridSlots;

    // クエリの設定
    var query = new Common.StockPricingDetailQuery();
    query.stockBalance = stockBalance;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.spdFooterReceiptQuantity = journals.map(obj => obj.receiptQuantity).reduce((total, value) =>(total + value));
      this.spdFooterReceiptAmount = journals.map(obj => obj.receiptAmount).reduce((total, value) =>(total + value));

      if(this.spdMonthlyAverage || this.spdSpecific || this.spdMovingAverage)
      {
        this.spdFooterWithDrawQuantity = journals.map(obj => obj.withDrawQuantity).reduce((total, value) =>(total + value));
        this.spdFooterWithDrawAmount = journals.map(obj => obj.pricingWithDrawAmount).reduce((total, value) =>(total + value));
        this.spdFooterQuantity = journals[journals.length -1].pricingQuantity;
        this.spdFooterAmount = journals[journals.length -1].pricingAmount;
        this.spdFooterPrice = journals[journals.length -1].pricingPrice;
      }
      else if(this.spdLastPurchase)
      {
        this.spdFooterQuantity = journals[journals.length -1].lastPurchaseQuantity;
        this.spdFooterAmount = journals[journals.length -1].lastPurchaseAmount;
        this.spdFooterPrice = journals[journals.length -1].lastPurchasePrice;
      }

      (this.$refs.showStockPricingDetailDialog as Components.ListDialog).items = (res as Common.LoadResult).result;
      (this.$refs.showStockPricingDetailDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());;
  }

  // 一覧でチェックされている在庫
  public checkedStockBalances: Array<Common.StockBalance>= new Array(0);
  public getCheckedStockBalances(){
    this.checkedStockBalances = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.stockRelocationQuantity = 0;
        obj.physicalStockQuantity = 0;
        obj.lossStockQuantity = obj.stockQuantity;
        this.checkedStockBalances.push(obj);
      }
    });
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 在庫系処理の共通チェック
  public stockCommonCheck():boolean
  {
    if(this.checkedStockBalances.length == 0){
      this.$api.modal.show('', '在庫を選択して下さい。', true, null);
      return false;
    }
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.commodity.isNoStock).length > 0){
      this.$api.modal.show('', '棚卸対象外商品の在庫は選択できません。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.warehouseId == null).length > 0){
      this.$api.modal.show('', '直送管理用の在庫は選択できません。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> this.checkedStockBalances[0].stockKey.segmentId != StockBalance.stockKey.segmentId).length > 0){
      this.$api.modal.show('', '単一部門の在庫を選択してください。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> this.checkedStockBalances[0].stockKey.warehouseId != StockBalance.stockKey.warehouseId).length > 0){
      this.$api.modal.show('', '単一倉庫を選択してください。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.closingDate != null && StockBalance.stockKey.segment.closingDate >= StockBalance.closingDate).length > 0){
      this.$api.modal.show('', '締処理済みの在庫が指定されています。部門または限月を変更して下さい。', true, null);
      return false;
    }

    return true;
  }

  // 在庫移動用プロパティ
  public asrSegment: Common.Segment = null;
  public asrPic: string = '';
  public asrWarehouseOut: Common.Counterpart = null;
  public asrWarehouseIn: Common.Counterpart = null;
  public asrBookDate: Date = new Date().getCalendarDate();
  public asrClosingDate:Date = new Date().getCalendarDate();
  public asrWorkflowId:number = 0;
  public asrCaptions = new Array();
  public asrWidths = new Array();
  public asrSlots = new Array();
  public asrStockRelocation: Common.StockRelocation = null;//ポップアップエディタ使用時の親伝票
  public asrUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ
  // ワークフロー処理用プロパティ
  public asrButtonNames: Array<string> = null;
  public asrButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public asrGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('移動可能数量', 150),
      new Common.GridItemConfiguration('移動数量', 150)
    ],
    6, //移動数量の次を予備項目の挿入位置に指定
    'col'
  );

  // 在庫移動子画面表示
  public showStockRelocationDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.asrGridConfig.setVariableItems(reserveItems);
    this.asrCaptions =this.asrGridConfig.gridCaptions;
    this.asrWidths = this.asrGridConfig.gridWidths;
    this.asrSlots = this.asrGridConfig.gridSlots;

    // 入力項目の初期化
    if (this.asrStockRelocation == null) {
      this.asrSegment = this.checkedStockBalances[0].stockKey.segment;
      this.asrPic = this.$api.auth.userId;
      this.asrWarehouseOut = this.checkedStockBalances[0].stockKey.warehouse;
      this.asrWarehouseIn = this.asrWarehouseOut;//初期値をセット
      this.asrBookDate = new Date().getCalendarDate();
      this.asrClosingDate = this.checkedStockBalances[0].closingDate;
      this.asrWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockRelocation');
    }      
    
    this.onStockRelocationChangeWorkflow();


    // ダイアログの表示
    (this.$refs.showStockRelocationDialog as Components.ListDialog).items = this.checkedStockBalances;
    (this.$refs.showStockRelocationDialog as Components.ListDialog).showDialog();
  }
  public onStockRelocationChangeWorkflow(){
    this.asrButtonNames=new Array();
    this.asrButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.asrButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.asrButtonNames.push("保存");
    if(this.asrWorkflowId!=0 && this.popup == null) //ポップアップエディタで表示された場合は既存伝票への追加モードになるので確定ボタンは追加しない
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockRelocation', this.asrWorkflowId, Common.StockRelocationStatus.PostWaiting);
      actions.forEach(action => {
        this.asrButtonNames.push(action.actionName);
        this.asrButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }

  public async submitAddStockRelocation(list: Array<Common.StockBalance>, index:number){

    // 入力時チェック
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockRelocationQuantity > 0).length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で移動数量を指定して下さい。').then(()=>false);
    }

    if(Moment(this.asrClosingDate).format('YYYYMM') != Moment(this.asrBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>false);
    }

    // クエリ設定
    var query = new Common.CreateStockRelocationQuery();
    query.pic = this.asrPic;
    query.warehouseIn = this.asrWarehouseIn;
    query.bookDate = this.asrBookDate;
    query.stockBalances = this.checkedStockBalances;
    query.workflowId = this.asrWorkflowId;
    query.actionId = this.asrButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockRelocation = this.asrStockRelocation; //ポップアップエディタを使用した追加モード時の親伝票

    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });

    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.asrUpdatedHandler){
        this.asrUpdatedHandler();
        return true;
      }
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockRelocation;
      //this.$api.modal.show('処理結果','以下の在庫移動伝票が作成されました。',true,null,[new Common.ModalLink(result.stockRelocationNo,String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo))]);
      this.$api.modal.show('処理結果','以下の在庫移動伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo)),[new Common.ModalLink(result.stockRelocationNo,String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});

  }

  // セット組立用プロパティ
  public saAssemblyQuantity:number = 0;
  public saLimitQuantity:number = 0;

  public showStockAssemblyDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(this.params.assembly == null){
      this.$api.modal.show('', 'セット組立時は検索条件タブで構成品抽出を指定して下さい。', true, null);
      return;
    }

    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific).length >0){
      this.$api.modal.show('', '在庫単価計算方法が個別法の部門は選択できません。', true, null);
      return;
    }
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.projectItemNo != this.checkedStockBalances[0].stockKey.projectItemNo).length >0){
      this.$api.modal.show('', '異なる案件の構成品からセット品組立を実施することはできません。', true, null);
      return;
    }
    // クエリの設定
    var query = new Common.StockAssemblyQuery();
    query.assembly = this.params.assembly;
    query.stockBalances = this.checkedStockBalances;
    this.saAssemblyQuantity = 0;

    // セット組立を実行する
    this.$api.execute(query).then(res => {
      this.saLimitQuantity = (res as Common.Component).limitQuantity;
      (this.$refs.showStockAssemblyDialog as Components.ListDialog).showDialog();
    });
  }

  public async submitStockAssembly(){
    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);

    var query = new Common.StockTransferItemOutQuery();
    query.assembly = this.params.assembly;
    query.assemblyQuantity = this.saAssemblyQuantity;
    query.stockBalances = this.checkedStockBalances;
    await this.$api.execute(query).then(res => {
      // 出庫設定
      this.stockTransferItemsOut = res;
      // 入庫設定
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = this.params.assembly.commodity;
      temp.commodityId = this.params.assembly.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = this.params.assembly.sku;
      temp.skuId = this.params.assembly.skuId;
      temp.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
      temp.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;
      temp.quantity = this.saAssemblyQuantity;
      temp.amount = this.astrTotalAmountOut;
      temp.reserveText1 = this.params.assembly.reserveText1;
      temp.reserveText2 = this.params.assembly.reserveText2;
      temp.reserveText3 = this.params.assembly.reserveText3;
      temp.reserveText4 = this.params.assembly.reserveText4;
      temp.reserveText5 = this.params.assembly.reserveText5;
      temp.reserveText6 = this.params.assembly.reserveText6;
      temp.reserveMemo1 = this.params.assembly.reserveMemo1;
      temp.reserveMemo2 = this.params.assembly.reserveMemo2;
      temp.reserveMemo3 = this.params.assembly.reserveMemo3;
      temp.reserveDate1 = this.params.assembly.reserveDate1;
      temp.reserveDate2 = this.params.assembly.reserveDate2;
      temp.reserveDate3 = this.params.assembly.reserveDate3;
      temp.reserveList1 = this.params.assembly.reserveList1;
      temp.reserveList2 = this.params.assembly.reserveList2;
      temp.reserveList3 = this.params.assembly.reserveList3;
      this.stockTransferItemsIn.push(temp);
      // 在庫振替起動
      this.showStockTransferDialog(Common.TransferTypes.Assemble,'セット組立',this.params.assembly.name);
    });

  }

  // セット分解用プロパティ
  public sdAssemblyQuantity: number = 0;
  public sdLimitQuantity:number = 0;
  public sdAssembly:Common.Assembly = null;

  public showStockDivideDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(this.checkedStockBalances.length > 1){
      this.$api.modal.show('', 'セット分解は単一在庫のみ可能です。', true, null);
      return;
    }

    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific).length >0){
      this.$api.modal.show('', '在庫単価計算方法が個別法の部門は選択できません。', true, null);
      return;
    }

    // クエリの設定
    var query = new Common.StockDivideQuery();
    query.stockBalance = this.checkedStockBalances[0];
    this.sdAssemblyQuantity = 0;
    this.sdLimitQuantity = this.checkedStockBalances[0].scheduleStockQuantity;

    // セット分解可能チェック
    this.$api.execute(query).then(res => {
      this.sdAssembly = res;
      (this.$refs.showStockDivideDialog as Components.ListDialog).showDialog();
    });
  }

  public async submitStockDivide(){
    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);

    var query = new Common.StockTransferItemInQuery();
    query.assembly = this.sdAssembly;
    query.assemblyQuantity = this.sdAssemblyQuantity;
    query.segment = this.checkedStockBalances[0].stockKey.segment;
    await this.$api.execute(query).then(res => {
      // 入庫設定
      this.stockTransferItemsIn = res;
      this.stockTransferItemsIn.forEach(item =>{
        item.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
        item.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;      
      });
      // 出庫設定
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = this.checkedStockBalances[0].stockKey.commodity;
      temp.commodityId = this.checkedStockBalances[0].stockKey.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = this.checkedStockBalances[0].stockKey.sku;
      temp.skuId = this.checkedStockBalances[0].stockKey.skuId;
      temp.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
      temp.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;      
      temp.availableQuantity = this.checkedStockBalances[0].scheduleStockQuantity;
      temp.quantity = this.sdAssemblyQuantity;
      temp.unitPrice = this.checkedStockBalances[0].stockPrice;
      temp.reserveText1 = this.checkedStockBalances[0].stockKey.reserveText1;
      temp.reserveText2 = this.checkedStockBalances[0].stockKey.reserveText2;
      temp.reserveText3 = this.checkedStockBalances[0].stockKey.reserveText3;
      temp.reserveText4 = this.checkedStockBalances[0].stockKey.reserveText4;
      temp.reserveText5 = this.checkedStockBalances[0].stockKey.reserveText5;
      temp.reserveText6 = this.checkedStockBalances[0].stockKey.reserveText6;
      temp.reserveMemo1 = this.checkedStockBalances[0].stockKey.reserveMemo1;
      temp.reserveMemo2 = this.checkedStockBalances[0].stockKey.reserveMemo2;
      temp.reserveMemo3 = this.checkedStockBalances[0].stockKey.reserveMemo3;
      temp.reserveDate1 = this.checkedStockBalances[0].stockKey.reserveDate1;
      temp.reserveDate2 = this.checkedStockBalances[0].stockKey.reserveDate2;
      temp.reserveDate3 = this.checkedStockBalances[0].stockKey.reserveDate3;
      temp.reserveList1 = this.checkedStockBalances[0].stockKey.reserveList1;
      temp.reserveList2 = this.checkedStockBalances[0].stockKey.reserveList2;
      temp.reserveList3 = this.checkedStockBalances[0].stockKey.reserveList3;
      temp.specificPurchaseItemId = this.checkedStockBalances[0].stockKey.deliveryId;
      this.stockTransferItemsOut.push(temp);
      // 在庫振替起動
      this.showStockTransferDialog(Common.TransferTypes.Divide,'セット分解',this.sdAssembly.name);
    });

  }

  // 在庫振替用プロパティ
  public astrPic: string = '';
  public astrBookDate: Date = new Date().getCalendarDate();
  public astrRefNo: string = '';
  public astrClosingDate:Date = new Date().getCalendarDate();
  public astrTransferFlag: Common.TransferTypes = Common.TransferTypes.Transfer;
  public checkTransferFlag: Common.TransferTypes = Common.TransferTypes.Transfer;
  public astrTransferFlagName: string = '';
  public astrAssemblyName:string = '';
  public astrSystemCurrency:Common.Currency = null;
  public astrWorkflowId : number = 0;
  public astrStockTransfer: Common.StockTransfer = null;//ポップアップエディタ使用時の親伝票
  public astrUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ

  public astrSegmentOut: Common.Segment = null;
  public astrWarehouseOut: Common.Counterpart = null;
  public get astrTotalAmountOut(): number {
    if(this.stockTransferItemsOut.length == 0) return 0;
    return this.stockTransferItemsOut.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }
  public astrSegmentIn: Common.Segment = null;
  public astrWarehouseIn: Common.Counterpart = null;
  public get astrTotalAmountIn(): number {
     if(this.stockTransferItemsIn.length == 0) return 0;
    return this.stockTransferItemsIn.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }

  public stockTransferItemsOut: Array<Common.StockTransferItem>= new Array(0);
  public stockTransferItemsIn: Array<Common.StockTransferItem>= new Array(0);

  public astrCaptionsOut = new Array();
  public astrWidthsOut = new Array();
  public astrSlotsOut = new Array();
  public astrGridConfigOut:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 60),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('振替可能数量', 110),
      new Common.GridItemConfiguration('振替数量', 100),
      new Common.GridItemConfiguration('出庫単価', 100),
      new Common.GridItemConfiguration('出庫金額', 100)
    ],
    8, //出庫金額の次を予備項目の挿入位置に指定
    'col'
  );
  public astrKeyOut: string = "astrKeyOut"; // 再描画用

  public astrCaptionsIn = new Array();
  public astrWidthsIn = new Array();
  public astrSlotsIn = new Array();
  public astrAmountScale: number = 0;
  // ワークフロー処理用プロパティ
  public astrButtonNames: Array<string> = null;
  public astrButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public astrGridConfigIn:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 80),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),        
      new Common.GridItemConfiguration('振替数量', 100),
      new Common.GridItemConfiguration('入庫金額', 100),
      new Common.GridItemConfiguration('入庫単価', 100),
    ],
    7, //入庫金額の次を予備項目の挿入位置に指定
    'col'
  );

  // 在庫振替表示事前処理
  public showPriviousStockTransferDialog(){
    this.getCheckedStockBalances();

    this.astrAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);
    this.checkedStockBalances.forEach((obj, index) => {
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = obj.stockKey.commodity;
      temp.commodityId = obj.stockKey.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = obj.stockKey.sku;
      temp.skuId = obj.stockKey.skuId;
      temp.projectItem = obj.stockKey.projectItem;
      temp.projectItemNo = obj.stockKey.projectItemNo;
      temp.availableQuantity = obj.scheduleStockQuantity;
      temp.quantity = 0;
      temp.unitPrice = obj.stockPrice;
      temp.amount = 0;
      temp.reserveText1 = obj.stockKey.reserveText1;
      temp.reserveText2 = obj.stockKey.reserveText2;
      temp.reserveText3 = obj.stockKey.reserveText3;
      temp.reserveText4 = obj.stockKey.reserveText4;
      temp.reserveText5 = obj.stockKey.reserveText5;
      temp.reserveText6 = obj.stockKey.reserveText6;
      temp.reserveMemo1 = obj.stockKey.reserveMemo1;
      temp.reserveMemo2 = obj.stockKey.reserveMemo2;
      temp.reserveMemo3 = obj.stockKey.reserveMemo3;
      temp.reserveDate1 = obj.stockKey.reserveDate1;
      temp.reserveDate2 = obj.stockKey.reserveDate2;
      temp.reserveDate3 = obj.stockKey.reserveDate3;
      temp.reserveList1 = obj.stockKey.reserveList1;
      temp.reserveList2 = obj.stockKey.reserveList2;
      temp.reserveList3 = obj.stockKey.reserveList3;
      temp.specificPurchaseItemId = obj.stockKey.deliveryId;
      temp.tempNo = index + 1;
      this.stockTransferItemsOut.push(temp);
      var temp2 = temp.copy();
      temp2.unitPrice = 0;
      temp2.specificPurchaseItemId = null;
      this.stockTransferItemsIn.push(temp2);
    });

    this.showStockTransferDialog(Common.TransferTypes.Transfer,'在庫振替');

  }

  public isEnabledRelocation(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.StockAttribute;
  }

  //入庫側の予備項目の編集可否を制御
  public isEnabledStockIn(usedType: Common.UsedTypes){
    //在庫振替の場合は商品識別情報と在庫識別情報のみ編集可。セット分解・組立の場合は在庫属性のみ
      if (this.astrTransferFlag == Common.TransferTypes.Transfer) {
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute) { return true;}else return false;
      }else return usedType == Common.UsedTypes.StockAttribute;
  }
  // 在庫振替
  public async showStockTransferDialog(flag:Common.TransferTypes,flagName:string,name:string = ''){

    // 予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.astrGridConfigOut.setVariableItems(reserveItems);
    this.astrCaptionsOut =this.astrGridConfigOut.gridCaptions;
    this.astrWidthsOut = this.astrGridConfigOut.gridWidths;
    this.astrSlotsOut = this.astrGridConfigOut.gridSlots;
    this.astrKeyOut = "astrKeyOut" + new Date();
    this.astrGridConfigIn.setVariableItems(reserveItems);
    this.astrCaptionsIn =this.astrGridConfigIn.gridCaptions;
    this.astrWidthsIn = this.astrGridConfigIn.gridWidths;
    this.astrSlotsIn = this.astrGridConfigIn.gridSlots;

    this.astrTransferFlag = flag;
    this.astrTransferFlagName = flagName;
    this.astrAssemblyName = name;
    // 入力項目初期化
    if (this.astrStockTransfer == null) {
      this.astrPic = this.$api.auth.userId;
      this.astrBookDate = new Date().getCalendarDate();
      this.astrRefNo = '';
      this.astrClosingDate = this.checkedStockBalances[0].closingDate;
      this.astrSegmentOut = this.checkedStockBalances[0].stockKey.segment;
      this.astrWarehouseOut = this.checkedStockBalances[0].stockKey.warehouse;
      this.astrSegmentIn = this.checkedStockBalances[0].stockKey.segment;
      this.astrWarehouseIn = this.checkedStockBalances[0].stockKey.warehouse;
      this.astrWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockTransfer');
    }

    this.onStockTransferChangeWorkflow();

    var query = new Common.GetSystemCurrecy();
    await this.$api.execute(query).then(res => {
      this.astrSystemCurrency = res;
      // 出庫金額の計算
      this.stockTransferItemsOut.forEach((obj, index) => {
        this.setTransferOutAmount(obj);
      });
      // 入庫単価の計算
      this.setTransferInPriceAll();
      // ダイアログの表示
      (this.$refs.showStockTransferDialog as Components.ListDialog).items = this.stockTransferItemsIn;
      (this.$refs.showStockTransferDialog as Components.ListDialog).showDialog();
    });
  }
  public onStockTransferChangeWorkflow(){
    this.astrButtonNames=new Array();
    this.astrButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.astrButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.astrButtonNames.push("保存");
    if(this.astrWorkflowId!=0 && this.popup == null)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockTransfer', this.astrWorkflowId, Common.StockTransferStatus.PostWaiting);
      actions.forEach(action => {
        this.astrButtonNames.push(action.actionName);
        this.astrButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }


  @Watch('stockTransferItemsOut',{deep:true})
  @Watch('stockTransferItemsIn',{deep:true})
  public setStockInAmount(){
    //入庫明細(1行目)の入庫金額に出庫金額-入庫金額を加算する
    if (this.stockTransferItemsOut && this.stockTransferItemsOut.length > 0 && this.stockTransferItemsIn && this.stockTransferItemsIn.length > 0){
      var stockOut = this.stockTransferItemsOut.map(obj =>obj.amount).reduce((previous,current)=>previous+current);
      var stockIn = this.stockTransferItemsIn.map(obj =>obj.amount).reduce((previous,current)=>previous+current);
      if (stockOut - stockIn != 0) {
        this.stockTransferItemsIn[0].amount += stockOut - stockIn;
        this.setTransferInPrice(this.stockTransferItemsIn[0]);//単価を再計算
      }
    }
  }


  public setTransferOutAmount(item:Common.StockTransferItem){
    var calcUtil:Common.CalcUtil = new Common.CalcUtil;
    item.amount = calcUtil.Round(item.quantity * item.unitPrice, this.astrSystemCurrency.precision, this.astrSystemCurrency.roundType);
    // 仕様を簡素化
    // if(this.astrTransferFlag == Common.TransferTypes.Transfer)
    // {
    //   var temp: Array<Common.StockTransferItem> = new Array(0);
    //   temp = this.stockTransferItemsIn.filter(obj => obj.tempNo == item.tempNo);
    //   if(temp.length > 0)
    //   {
    //     temp[0].amount = item.amount;
    //     this.setTransferInPrice(temp[0]);
    //   }
    // }
    // else if(this.astrTransferFlag == Common.TransferTypes.Assemble)
    // {
    //   this.stockTransferItemsIn[0].amount = this.astrTotalAmountOut;
    //   this.setTransferInPrice( this.stockTransferItemsIn[0])
    // }
    // else if(this.astrTransferFlag == Common.TransferTypes.Divide)
    // {
    //   var totalDivideReferenceAmount: number;
    //   totalDivideReferenceAmount = this.stockTransferItemsIn.map(obj => obj.divideReferenceAmount).reduce((total, value) =>(total + value));
    //   this.stockTransferItemsIn.forEach((obj, index) => {
    //     obj.amount = calcUtil.Round(this.astrTotalAmountOut * obj.divideReferenceAmount / totalDivideReferenceAmount, this.astrSystemCurrency.precision, this.astrSystemCurrency.roundType);
    //   });
    //   // 差分調整(1行目に調整)
    //   var differenceAmount = this.astrTotalAmountOut - this.astrTotalAmountIn;
    //   if(differenceAmount != 0) this.stockTransferItemsIn[0].amount += differenceAmount;

    //   this.stockTransferItemsIn.forEach((obj, index) => {
    //     this.setTransferInPrice(obj);
    //   });
    // }
  }

  public setTransferInPrice(item:Common.StockTransferItem){
    if(item.quantity == 0) item.unitPrice = 0;
    else
    {
      item.unitPrice = item.amount / item.quantity;
      if(item.commodity != null)
      {
        var calcUtil:Common.CalcUtil = new Common.CalcUtil;
        item.unitPrice = calcUtil.Round(item.unitPrice, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
      }
    }
  }

  public setTransferInPriceAll(){
    this.stockTransferItemsIn.forEach((obj, index) => {
      this.setTransferInPrice(obj);
    });
  }

  public setPackage(item:Common.StockTransferItem){
    if(item.commodity == null) item.package = '';
    else item.package = item.commodity.uom;
  }

  public isEditable(inputType:Common.InputTypes,stockType:Common.StockTypes):boolean{
    if(stockType == null) return false;
    if(inputType != Common.InputTypes.None && stockType != Common.StockTypes.None && this.astrTransferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  public isEditableRow():boolean{
    if(this.astrTransferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  public async submitAddStockTransfer(list: Array<Common.StockTransferItem>, index:number){

    // 入力時チェック
    if(this.astrSegmentIn.priceCalculationMethod == Common.PricingTypes.Specific){
      return this.$api.modal.showDialog('','入庫部門に在庫単価計算方法が個別法の部門を指定することはできません。').then(()=>{return false;});;
    }

    if(Moment(this.astrClosingDate).format('YYYYMM') != Moment(this.astrBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>{return false;});;
    }

    if(this.stockTransferItemsOut.filter(item=> item.quantity > 0).length == 0){
      return this.$api.modal.showDialog('', '出庫側の振替数量を入力して下さい。').then(()=>{return false;});
    }

    if(this.stockTransferItemsIn.filter(item=> item.quantity > 0).length == 0){
      return this.$api.modal.showDialog('', '入庫側の振替数量を入力して下さい。').then(()=>{return false;});
    }
    if(this.stockTransferItemsIn.filter(item=> item.amount <= 0).length > 0){
      return this.$api.modal.showDialog('', '入庫金額がゼロ以下にならないように調整して下さい。').then(()=>{return false;});
    }
    if(this.astrSegmentOut.id == this.astrSegmentIn.id && this.astrWarehouseOut.id == this.astrWarehouseIn.id)
    {
      for (var i = 0; i < this.stockTransferItemsOut.length; i++) {
         if(this.stockTransferItemsIn.filter(item=>
            (item.commodity ? item.commodity.id : 0) == this.stockTransferItemsOut[i].commodityId && (item.sku ? item.sku.id :0) == this.stockTransferItemsOut[i].skuId && //in側のcommodityIdとskuIdは更新されていない
            item.reserveText1 == this.stockTransferItemsOut[i].reserveText1 && item.reserveText2 == this.stockTransferItemsOut[i].reserveText2 && item.reserveText3 == this.stockTransferItemsOut[i].reserveText3 &&
            item.reserveText4 == this.stockTransferItemsOut[i].reserveText4 && item.reserveText5 == this.stockTransferItemsOut[i].reserveText5 && item.reserveText6 == this.stockTransferItemsOut[i].reserveText6 &&
            item.reserveMemo1 == this.stockTransferItemsOut[i].reserveMemo1 && item.reserveMemo2 == this.stockTransferItemsOut[i].reserveMemo2 && item.reserveMemo3 == this.stockTransferItemsOut[i].reserveMemo3 &&
            item.reserveDate1 == this.stockTransferItemsOut[i].reserveDate1 && item.reserveDate2 == this.stockTransferItemsOut[i].reserveDate2 && item.reserveDate3 == this.stockTransferItemsOut[i].reserveDate3 &&
            item.reserveList1 == this.stockTransferItemsOut[i].reserveList1 && item.reserveList2 == this.stockTransferItemsOut[i].reserveList2 && item.reserveList3 == this.stockTransferItemsOut[i].reserveList3).length > 0) {
          return this.$api.modal.showDialog('', '出庫側と入庫側で同じ在庫が指定されています。').then(()=>{return false;});
        }
      }
    }

    if(this.astrTotalAmountOut != this.astrTotalAmountIn){
      return this.$api.modal.showDialog('無効な操作', '出庫側と入庫側の合計金額が不一致です。').then(()=>{return false;});
    }

    // クエリ設定
    var query = new Common.CreateStockTransferQuery();
    query.transferFlag = this.astrTransferFlag;
    query.pic = this.astrPic;
    query.bookDate = this.astrBookDate;
    query.refNo = this.astrRefNo;
    query.closingDate = this.astrClosingDate;
    query.segmentOut = this.astrSegmentOut;
    query.segmentIn = this.astrSegmentIn;
    query.warehouseOut = this.astrWarehouseOut;
    query.warehouseIn = this.astrWarehouseIn;
    query.stockTransferItemsOut = this.stockTransferItemsOut;
    query.stockTransferItemsIn = this.stockTransferItemsIn;
    query.workflowId = this.astrWorkflowId;
    query.actionId = this.astrButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockTransfer = this.astrStockTransfer;
    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });
    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.astrUpdatedHandler){
        this.astrUpdatedHandler();
        return true;
      }            
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockTransfer;
      //this.$api.modal.show('処理結果','以下の在庫振替伝票が作成されました。',true,null,[new Common.ModalLink(result.stockTransferNo,String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo))]);
      this.$api.modal.show('処理結果','以下の在庫振替伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo)),[new Common.ModalLink(result.stockTransferNo,String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});
  }

  // 棚卸処理用プロパティ
  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.stock) > 0 ;
  }  
  public astkPic: string = '';
  public astkBookDate: Date = new Date().getCalendarDate();
  public astkRefNo: string = '';
  public astkBarcodeInspection:boolean = false;  
  public astkSegment: Common.Segment = null;
  public astkWarehouse: Common.Counterpart = null;
  public astkClosingDate:Date = new Date().getCalendarDate();
  public astkWorkflowId:number = 0;
  public astkCaptions = new Array();
  public astkWidths = new Array();
  public astkSlots = new Array();
  public astkStockTaking: Common.StockTaking = null;//ポップアップエディタ使用時の親伝票
  public astkUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ  
  // ワークフロー処理用プロパティ
  public astkButtonNames: Array<string> = null;
  public astkButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public astkGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 80),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('庫内数量', 100),
      new Common.GridItemConfiguration('実地棚卸数量', 100),
      new Common.GridItemConfiguration('減耗数量', 100)
    ],
    7, //減耗数量の次を予備項目の挿入位置に指定
    'col'
  );

  @Watch('astkBarcodeInspection')
  public onBarcodeInspectionChanged(){
      this.astkGridConfig.baseConfigurations[4].IsVisible = !this.astkBarcodeInspection;
      this.astkGridConfig.baseConfigurations[5].IsVisible = !this.astkBarcodeInspection;
      this.astkGridConfig.setGridItems();
      this.astkCaptions =this.astkGridConfig.gridCaptions;
      this.astkWidths = this.astkGridConfig.gridWidths;
      this.astkSlots = this.astkGridConfig.gridSlots;      
  }
  // 棚卸処理子画面表示
  public showStockTakingDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.astkGridConfig.setVariableItems(reserveItems);
    this.astkCaptions =this.astkGridConfig.gridCaptions;
    this.astkWidths = this.astkGridConfig.gridWidths;
    this.astkSlots = this.astkGridConfig.gridSlots;

    // 入力項目の初期化
    if (this.astkStockTaking == null) {
      this.astkPic = this.$api.auth.userId;
      this.astkBookDate = new Date().getCalendarDate();
      this.astkRefNo = '';
      this.astkSegment = this.checkedStockBalances[0].stockKey.segment;
      this.astkWarehouse = this.checkedStockBalances[0].stockKey.warehouse;
      this.astkClosingDate = this.checkedStockBalances[0].closingDate;
      this.astkWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockTaking');
    }    
    this.onStockTakingChangeWorkflow();
    // クエリの設定
    var query = new Common.CheckStockTakingQuery();
    query.stockBalances = this.checkedStockBalances;

    // 棚卸処理可能チェック
    this.$api.execute(query).then(res => {
      // ダイアログの表示
      (this.$refs.showStockTakingDialog as Components.ListDialog).items = this.checkedStockBalances;
      (this.$refs.showStockTakingDialog as Components.ListDialog).showDialog();
    });
  }

  public setLossStockQuantity(item: Common.StockBalance){
    // 浮動小数点のフォーマットを行い、小数点以下の桁を指定された桁数までまとめる
    // item.lossStockQuantity = this.$api.formatter.formatNumber((item.stockQuantity - item.physicalStockQuantity), item.stockKey.commodity.quantityScale);
    item.lossStockQuantity = this.calcUtil.Round((item.stockQuantity - item.physicalStockQuantity), item.stockKey.commodity.quantityScale, item.stockKey.commodity.quantityRound)
  }

  public async submitAddStockTaking(list: Array<Common.StockBalance>, index:number){
    // 入力時チェック
    if(Moment(this.astkClosingDate).format('YYYYMM') != Moment(this.astkBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>false);
    }

    // クエリ設定
    var query = new Common.CreateStockTakingQuery();
    query.pic = this.astkPic;
    query.bookDate = this.astkBookDate;
    query.refNo = this.astkRefNo;
    query.barcodeInspection = this.astkBarcodeInspection;
    query.stockBalances = this.checkedStockBalances;
    query.workflowId = this.astkWorkflowId;
    query.actionId = this.astkButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockTaking = this.astkStockTaking; //ポップアップエディタを使用した追加モード時の親伝票
    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });

    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.astkUpdatedHandler){
        this.astkUpdatedHandler();
        return true;
      }      
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockTaking;
      //this.$api.modal.show('処理結果','以下の棚卸処理伝票が作成されました。',true,null,[new Common.ModalLink(result.stockTakingNo,String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo))]);
      this.$api.modal.show('処理結果','以下の棚卸処理伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo)),[new Common.ModalLink(result.stockTakingNo,String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});

  }
  public onStockTakingChangeWorkflow(){
    this.astkButtonNames=new Array();
    this.astkButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.astkButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.astkButtonNames.push("保存");
    if(this.astkWorkflowId!=0 && this.popup == null)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockTaking', this.astkWorkflowId, Common.StockTakingStatus.PostWaiting);
      actions.forEach(action => {
        this.astkButtonNames.push(action.actionName);
        this.astkButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }



  //諸掛按分処理
  //諸掛按分処理用プロパティ
  public caConfig:Common.GridConfiguration = new Common.GridConfiguration([],0,'col');
  public caPic: string = '';
  public caBookDate: Date = new Date().getCalendarDate();
  public caCurrencyCode: string='';
  public caProportionalDivision: Common.ProportionalDivisionFlags = Common.ProportionalDivisionFlags.ByQuantity;
  public caExchangeRate:number = 0;
  public caRefNo : string = '';
  public caWorkflowId: number = 0;
  public caItems : Common.PurchaseCharge[] = [];
  public caAmountScale : number = 0;
  // ワークフロー処理用プロパティ
  public caButtonNames: Array<string> = null;
  public caButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showChargeAllocationDialog() {
    this.getCheckedStockBalances();

    this.caAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);
    // ダイアログ表示前バリデーション
    if(this.checkedStockBalances.length == 0){
      this.$api.modal.show('', '在庫を選択して下さい。', true, null);
      return;
    }
    // if(this.checkedStockBalances.filter(item => item.state != Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted).length > 0){
    //   this.$api.modal.show('', '未処理・入荷待ちの明細は選択できません。', true, null);
    //   return;
    // }
    if(this.checkedStockBalances.filter(item => item.stockKey.segment.id != this.checkedStockBalances[0].stockKey.segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる在庫を、同じ諸掛伝票にまとめることはできません。', true, null);
      return;
    }

    this.caConfig = new Common.GridConfiguration([],0,'col');
    this.caConfig.setGridItems(
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('支払予定日', 150),
    );

    // プロパティの初期化
    this.caPic = this.$api.auth.userId;
    this.caBookDate = new Date().getCalendarDate();
    this.caCurrencyCode = (this.$api.tenantSettings as Common.TenantSettings).currencyCode;
    this.caExchangeRate = 1;

    //ワークフロー初期値のセット
    const workflows = this.$api.formatter.getOptions('workflow_charge');
    if (workflows.length > 0) this.caWorkflowId = workflows[0].value;
    this.onChargeAllocationChangeWorkflow();
    
    // ダイアログの表示
    // var items = this.checkedDeliveryItems.map(item => item.copy());
    this.caItems = new Array();
    this.caItems.push(new Common.PurchaseCharge());
    (this.$refs.chargeAllocationDialog as Components.ListDialog).items = this.caItems;
    (this.$refs.chargeAllocationDialog as Components.ListDialog).showDialog();
  }
  public onChargeAllocationChangeWorkflow(){
    this.caButtonNames=new Array();
    this.caButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.caButtonNames.push("諸掛保存");
    if(this.caWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('charge', this.caWorkflowId, Common.ChargeStatus.ChargeSaving);
      actions.forEach(action => {
        this.caButtonNames.push(action.actionName);
        this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  // 取引先変更時に取引先の税区分・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge){
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    if(item.counterpart == null) item.dueDate = null;
    else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(){
    this.caItems.forEach(item =>{
      if(item.counterpart == null) item.dueDate = null;
      else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
    });
    this.onChangeCurrency();
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(){

    this.caAmountScale = this.calcUtil.GetCurrecyDecimal(this.caCurrencyCode,this.$api);

    const query = new Common.GetExchangeRateQuery();
    query.currency = this.caCurrencyCode;
    query.startDate = this.caBookDate;

    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.caExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });

  }

   public async submitChargeAllocation(list: Array<Common.SalesCharge>, index:number){
    // 選択している入荷伝票の取得
    if (this.caItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','諸掛を入力してください。').then(()=>{return false;});
    }

    if (this.checkedStockBalances.filter(obj =>obj.closingDate.getBeginDate() > this.caBookDate).length > 0){ //月初日と比較
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','限月よりも前の発生日が入力されています。').then(()=>{return false;});
    }

    //ヘッダプロパティの設定
    this.caItems.forEach(charge =>{
      charge.currencyCode = this.caCurrencyCode;
      charge.exchangeRate = this.caExchangeRate;
      charge.proportionalDivision = this.caProportionalDivision;
      charge.workflowId = this.caWorkflowId;
      charge.chargeDate = this.caBookDate;
      charge.pic = this.caPic;
      charge.refNo = this.caRefNo;
      charge.chargeFlag = Common.SalesPurchaseFlags.Purchase; //仕入諸掛
      charge.segment = this.checkedStockBalances[0].stockKey.segment;
      charge.target = Common.ChargeItemTypes.Stock;
    });

    // クエリの設定
    var query = new Common.AddStockChargeAllocationQuery();
    query.charges = this.caItems; //諸掛のセット
    query.stockBalances = this.checkedStockBalances; //按分対象のセット
    query.actionId = this.caButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    // 諸掛按分明細追加の実行
    return this.$api.execute(query,true).then(res => {
      //ダイアログ表示
      var charges = res as Common.PurchaseCharge[];
      var links = charges.map(charge=>new Common.ModalLink(charge.chargeNo,String.format('/purchase/PurchaseCharge?chargeNo={0}',charge.chargeNo)));
      // this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',false,()=>this.$router.push(String.format('/purchase/PurchaseCharge?chargeNo={0}',charges[0].chargeNo)),links,'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});
   }
}
